export default __webpack_public_path__ + "static/media/Return.9f6ac149.png";